module.exports = __webpack_public_path__ + "e94f3f7990e5e94a5a9ce7fb4ae56ec0.woff2";